import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { IIap } from '~/types/iap'

import { IapTypeBadge } from '~/components/Badges'

const IapTypeCellRenderer = ({ value }: ICellRendererParams<IIap, IIap['type']>): ReactElement => {
  return value ? <IapTypeBadge value={value} /> : <div />
}

export default IapTypeCellRenderer
